// extracted by mini-css-extract-plugin
export default {"button":"ButtonComponent_button__480e8","red":"ButtonComponent_red__mPhPH","blue":"ButtonComponent_blue__+dBBq","green":"ButtonComponent_green__ObabU"};